export { updateUserConfigurationService } from './services/updateUserConfigurationService';
